import React from 'react';
import moment from 'moment';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';

// Filter persistence for Missões / Convites (/marketing/*). Each board keeps
// its own month (stored as 'YYYY-MM'; the board components use 'MM-YYYY').

export var MARKETING_FILTER_KEYS = {
  missoes: 'marketing.missoes',
  convites: 'marketing.convites',
};

export var getDefaultMarketingFilters = function() {
  return {
    month: moment().format('YYYY-MM'),
  };
};

// 'YYYY-MM' (stored) -> 'MM-YYYY' (board/header/redux selectedDate)
export var toBoardDate = function(month) {
  return moment(month, 'YYYY-MM').format('MM-YYYY');
};

// 'MM-YYYY' -> 'YYYY-MM'
export var toStoredMonth = function(boardDate) {
  return moment(boardDate, 'MM-YYYY').format('YYYY-MM');
};

// Params for boardActions.load (month is 1-12).
export var getMonthYear = function(month) {
  var m = moment(month, 'YYYY-MM');
  return { month: m.month() + 1, year: m.year() };
};

// The IndexedDB cache only ever holds the current month of each board: using
// it for another month would flash the wrong cards until the fetch returns.
export var shouldUseMarketingCache = function(month, now) {
  return month === moment(now || undefined).format('YYYY-MM');
};

// LocalCacheHandler only uses `pathname` as part of the key, so one key per board.
export var getMarketingCachePathname = function(boardType) {
  return CACHE_ACTIONS.marketing + ':' + boardType;
};

// Badge: only what differs from the defaults (search counts as one filter).
export var countActiveMarketingFilters = function(filters, defaults, searchQuery) {
  return (filters.month !== defaults.month ? 1 : 0) + (searchQuery ? 1 : 0);
};

// Lets the shared Header reach the page's persisted filters without threading
// them through the board components. `null` when no page provides it.
export var MarketingFiltersContext = React.createContext(null);
